export default __webpack_public_path__ + "static/media/cliente1.d39c9770.jpg";